<ng-container *ngIf="loaders.isComponentLoading(loader)">
    <mat-spinner *ngIf="!svg" diameter="{{size}}" class="mat-btn-spinner {{color}}"></mat-spinner>
    <span class="svg-loader mt-2 mb-2" *ngIf="svg"></span>
</ng-container>